// ------------------------------------------------------------------------------
// <auto-generated>
//     This file was generated by TypeScript Definition Generator v2.2.8.0
// </auto-generated>
// ------------------------------------------------------------------------------
/** 
 * In the future website should work worldwide, for MVP we split in regions
 */
export enum Region {
	Madeira,
	Latvia,
	LaPalma,
}
